<template>
  <XBaseRadio
    ref="radio"
    :boxClass="boxClasses"
    v-model="checkValue"
    @change="onChange"
    v-bind="$props"
    v-on="$listeners">
    <template slot="label">
      <slot name="label" />
    </template>
    <template slot="optional">
      {{ $t('common.formFields.fields.optional') }}
    </template>
    <template slot="extra">
      <slot name="extra" />
    </template>
  </XBaseRadio>
</template>

<script>
import XBaseRadio from '@common/components/BaseRadio'

const INHERIT_PROPS = XBaseRadio.mixins.reduce((carry, mixin) => ({ ...carry, ...mixin.props }), XBaseRadio.props)

export default {
  components: { XBaseRadio },

  model: {
    prop: 'modelValue',
    event: 'input'
  },

  props: {
    ...INHERIT_PROPS,

    boxClass: {
      type: Object,
      default: function () {
        return {
          box: [],
          circle: []
        }
      }
    },
    color: {
      type: String,
      default: 'primary'
    }
  },

  data () {
    return {
      checkValue: this.modelValue,
      state: false
    }
  },

  watch: {
    modelValue: function (newVal) {
      this.checkValue = newVal
    }
  },

  computed: {
    listeners () {
      let listeners = { ...this.$listeners }

      delete listeners.change

      return listeners
    },

    boxClasses () {
      return {
        box: [...COLORS[this.color].box.default, ...this.boxClass.box, {
          [COLORS[this.color].box.active.join(' ')]: this.state,
          'border-grey-80': !this.state
        }],
        circle: [...COLORS[this.color].circle, ...this.boxClass.circle]
      }
    }
  },

  mounted () {
    this.state = this.$refs.radio.state
  },

  methods: {
    onChange (data) {
      this.state = data.state
    }
  }
}

const COLORS = {
  primary: {
    box: {
      default: [
        'overflow-hidden',
        'm-0',
        'p-0',
        'bg-white',
        'border'
      ],
      active: ['border-info-50']
    },
    circle: ['bg-info-50']
  },
  secondary: {
    box: {
      default: [
        'overflow-hidden',
        'm-0',
        'p-0',
        'bg-white',
        'border'
      ],
      active: ['border-info-50']
    },
    circle: ['bg-info-50']
  },
  white: {
    box: {
      default: [
        'overflow-hidden',
        'm-0',
        'p-0',
        'bg-white',
        'border'
      ],
      active: ['border-grey-40']
    },
    circle: ['bg-grey-40']
  }
}
</script>
